import { SEO_TITLE_BLOGS_SHORT_MESSAGE_OF_username } from 'mk/autogenerated/translations/BlogsPostSplitterPage.73ff39afec7c5dd08b20178b00845069'
import { blogsRedirectToTargetTrigger } from 'mk2/apps/blogs/containers/BlogsPostSplitter/BlogsPostSplitter.actions';
import blogsPostSplitterSaga from 'mk2/apps/blogs/containers/BlogsPostSplitter/BlogsPostSplitter.sagas';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import Page from 'mk2/pages/Page';
import {
    AppState,
} from 'mk2/reducers';
import { HistoryLocationState } from 'mk2/services/browserHistory';
import { interpolate } from 'mk2/services/i18n';
import { Store } from 'mk2/store/configureStore';
import React from 'react';
import { MapStateToPropsParam } from 'react-redux';
import { RouteComponentProps, StaticContext } from 'react-router';

class BlogsPostSplitter extends React.PureComponent<Props> {

    public componentDidMount() {
        this.handleRedirectToTarget();
    }

    public render() {
        return null;
    }

    private handleRedirectToTarget = () => {
        const { onRedirectToTarget, match: { params: { username, postId } } } = this.props;
        onRedirectToTarget(username, parseInt(postId, 10));
    };

}

interface OwnProps {}

interface StateProps {}

interface DispatchProps {
    onRedirectToTarget(username: string, postId: number);
}

type RouteProps = RouteComponentProps<{
    username: string;
    postId: string;
}, StaticContext, HistoryLocationState>;

export type Props = OwnProps & StateProps & DispatchProps & RouteProps;

export default class BlogsPostSplitterPage extends Page<OwnProps & RouteProps, StateProps, DispatchProps> {

    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            return {};
        };
    }

    public mapDispatchToProps(): MapDispatchToPropsObject<DispatchProps> {
        return {
            onRedirectToTarget: blogsRedirectToTargetTrigger,
        };
    }

    public getMetaTitle(props: Props): string {
        const { match: { params: { username } } } = props;
        return interpolate(SEO_TITLE_BLOGS_SHORT_MESSAGE_OF_username, { username });
    }

    public render(props: Props): false | JSX.Element {
        return (
            <BlogsPostSplitter {...props} />
        );
    }

    public hasHeaderBackButton(props: Props): boolean {
        return false;
    }

    public registerInStore(store: Store<AppState>) {
        store.injectSaga('containers.blogs.BlogsPostSplitter', blogsPostSplitterSaga);
    }
}
